import React, { useEffect } from 'react';
import LiveGamesPage from './pages/live/LiveGamesPage';
import './App.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLiveChampionships, fetchLiveSportTypes, fetchSelectedOdds, selectCurrentGames, selectCurrentSportType, selectCurrentSubSportType, selectDefaultSportType, selectLiveGames, selectSportType, selectSportTypes } from './pages/live/LiveSlice';
import { useHistory, useParams } from 'react-router-dom';
import { SPORT_DATA_UPDATE_INTERVAL } from './app/const';
import { RootState } from './app/store';
interface UrlParams {
  urlSportType: string
}

function App() {
  const dispatch = useDispatch()
  const history = useHistory()
  const { urlSportType } = useParams<UrlParams>()

  const currentGames = useSelector(selectCurrentGames)
  let currentSportType = useSelector(selectCurrentSportType)
  const currentSubSportType = useSelector(selectCurrentSubSportType)
  const sportTypes = useSelector(selectSportTypes)
  const collapsedChampionships = useSelector(
    (state: RootState) => state.liveGames.collapsedChampionships
  )
  const liveGamesStatus = useSelector(
    (state: RootState) => state.liveGames.championshipsFetchStatus
  )
  const sportTypesStatus = useSelector(
    (state: RootState) => state.liveGames.sportTypesFetchStatus
  )
  const selectedOddsStatus = useSelector(
    (state: RootState) => state.liveGames.selectedOddsFetchStatus
  )
  const subSportTypes = useSelector(
    (state: RootState) => state.liveGames.subSports
  )

  const collapsedSections = useSelector(
    (state: RootState) => state.liveGames.collapsedSections
  )
  const selectedOdds = useSelector(
    (state: RootState) => state.liveGames.selectedOdds
  )
  const isSearching = useSelector(
    (state: RootState) => state.liveGames.isSearching
  )
  const favorites = useSelector((state: RootState) => state.liveGames.favorites)
  // currentSportType = urlSportType
  //   ? sportTypes.find((s) => s.Id === urlSportType)?.Id
  //     ? urlSportType
  //     : currentSportType
  //   : currentSportType

  currentSportType = urlSportType ?? currentSportType

  
  dispatch(selectSportType({ sportTypeId: currentSportType }))
  
  const liveGames = useSelector(selectLiveGames)

  useEffect(() => {
    dispatch(fetchLiveChampionships())
  }, [favorites, currentGames, currentSportType, currentSubSportType, dispatch])

  useEffect(() => {
    dispatch(fetchLiveSportTypes())
  }, [favorites, dispatch])

  useEffect(() => {
    const messagReceiver = (e: MessageEvent) => {
      if (e?.data?.type === 'UPDATE_ODDS') {
        dispatch(fetchSelectedOdds())
      }
    }
    window.addEventListener('message', messagReceiver)
    return () => {
      window.removeEventListener('message', messagReceiver)
    }
  }, [dispatch])

  useEffect(() => {
    const timer = setInterval(() => {
      dispatch(fetchSelectedOdds())
    }, SPORT_DATA_UPDATE_INTERVAL)
    return () => {
      clearInterval(timer)
    }
  }, [dispatch, selectedOdds])

  useEffect(() => {
    const timer = setInterval(() => {
      dispatch(fetchLiveChampionships())
    }, SPORT_DATA_UPDATE_INTERVAL)
    return () => {
      clearInterval(timer)
    }
  }, [dispatch, liveGames])

  useEffect(() => {
    const timer = setInterval(() => {
      dispatch(fetchLiveSportTypes())
    }, SPORT_DATA_UPDATE_INTERVAL)
    return () => {
      clearInterval(timer)
    }
  }, [dispatch, sportTypes])


  useEffect(() => {
    if (sportTypesStatus === 'idle') {
      dispatch(fetchLiveSportTypes())
    }
    if (liveGamesStatus === 'idle') {
      dispatch(fetchLiveChampionships())
    }
    if (selectedOddsStatus === 'idle') {
      dispatch(fetchSelectedOdds())
    }
  }, [liveGamesStatus, sportTypesStatus, selectedOddsStatus, dispatch])
  
  useEffect(() => {
    if (!liveGames /*|| sportTypes.find((s) => s.Id == currentSportType)?.Id*/) {
      dispatch(selectDefaultSportType())
      dispatch(fetchLiveChampionships())
      history.push(`/live/`)
    }
    
  }, [dispatch, history, liveGames, sportTypes])

  return (
    <LiveGamesPage
      currentGames={currentGames}
      currentSportType={currentSportType}
      currentSubSportType={currentSubSportType}
      liveGames={liveGames}
      collapsedChampionships={collapsedChampionships}
      sportTypes={sportTypes}
      subSportTypes={subSportTypes}
      collapsedSections={collapsedSections}
      urlSportType={urlSportType}
      isSearching={isSearching}
    />
  )
}

export default App
